export default __webpack_public_path__ + "static/media/wait4_part.ae819279.mp3";